import React from 'react'

const CategoryInfo = ({ title, className = '', id, children }) => (
  <div className={`category-info ${className}`} id={id}>
    {!!title && <h3 className="category-title">{title}</h3>}
    <div className="category-description">{children}</div>
  </div>
)

export default CategoryInfo
